<template>
  <div>
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>

    <div class="gameplay_game_box_list gameplay_tap_box att6">
      <div class="gameplay_tap_container odd" >

        <div class="gameplay_btns_row" v-for="(row, rowindex) in gameInfo.answerList.length/2" :key="rowindex">
          <div :disabled="buttonPushed" type="" class="knot_box" v-for="(answer, index) in getPartOfAnswers(row)" :key="index"
                  @click.prevent="sendAnswer(row, (index + 1))"
                  :ref="index + 1">
            <img :src=matrixImages[answer]>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  /* eslint no-console: "off" */

import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { equalHeightAndWidth, gameplayFooter } from '@/common/jQuery';

export default {
  name: 'AttentionKnots',
  mixins: [ParseResponseMixin, NewGameMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      buttonPushed: false,
      matrixImages: {
        KNOT1a: 'static/images/game_images/attention_06/ATT_06_01_a.png',
        KNOT1b: 'static/images/game_images/attention_06/ATT_06_01_b.png',
        KNOT1c: 'static/images/game_images/attention_06/ΑΤΤ_06_01_c.png',
        KNOT1d: 'static/images/game_images/attention_06/ΑΤΤ_06_01_d.png',
        KNOT2a: 'static/images/game_images/attention_06/ΑΤΤ_06_02_a.png',
        KNOT2b: 'static/images/game_images/attention_06/ΑΤΤ_06_02_b.png',
        KNOT2c: 'static/images/game_images/attention_06/ΑΤΤ_06_02_c.png',
        KNOT2d: 'static/images/game_images/attention_06/ΑΤΤ_06_02_d.png',
        KNOT3a: 'static/images/game_images/attention_06/ΑΤΤ_06_03_a.png',
        KNOT3b: 'static/images/game_images/attention_06/ΑΤΤ_06_03_b.png',
        KNOT3c: 'static/images/game_images/attention_06/ΑΤΤ_06_03_c.png',
        KNOT3d: 'static/images/game_images/attention_06/ΑΤΤ_06_03_d.png',
        KNOT4a: 'static/images/game_images/attention_06/ΑΤΤ_06_04_a.png',
        KNOT4b: 'static/images/game_images/attention_06/ΑΤΤ_06_04_b.png',
        KNOT4c: 'static/images/game_images/attention_06/ΑΤΤ_06_04_c.png',
        KNOT4d: 'static/images/game_images/attention_06/ΑΤΤ_06_04_d.png',
        KNOT5a: 'static/images/game_images/attention_06/ΑΤΤ_06_05_a.png',
        KNOT5b: 'static/images/game_images/attention_06/ΑΤΤ_06_05_b.png',
        KNOT5c: 'static/images/game_images/attention_06/ΑΤΤ_06_05_c.png',
        KNOT5d: 'static/images/game_images/attention_06/ΑΤΤ_06_05_d.png',
      },
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    equalHeightAndWidth();
  },
  methods: {
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.gameInfo.answerList.slice(0, this.gameInfo.answerList.length / 2);
      }
      return this.gameInfo.answerList.slice(this.gameInfo.answerList.length / 2);
    },
    calculateRefIndex(indexToBack) {
      // eslint-disable-next-line no-nested-ternary
      return (indexToBack === 0) ? this.$refs[1][0] : (indexToBack === 1) ? this.$refs[2][0] : (indexToBack === 2) ? this.$refs[1][1] : this.$refs[2][1];
    },
    sendAnswer(row, index) {
      // eslint-disable-next-line no-nested-ternary
      const indexToBack = (row === 1) ? ((row * index) - 1) : (index === 1) ? 2 : 3;
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${indexToBack}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.calculateRefIndex(indexToBack).classList.add('gameplay_btn_false');
              this.calculateRefIndex(responseData.correctIndex).classList.add('gameplay_btn_correct');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.calculateRefIndex(indexToBack).classList.add('gameplay_btn_correct');
            }
          }
          console.log('wait 1,5 secs for response and go to next game');
          setTimeout(() => {
            console.log('Go to next game');
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionKnots.vue